import { Theme } from "PFApp/theme_context_provider";
import { useTheme } from "PFApp/theme_context_provider/theme_context_provider_context";
import { Color } from "PFCore/types";
import colors from "PFTheme/tokens/colors";
import { useCallback } from "react";

type UseGetColorReturn = (color: Color) => Color;

export const useGetColor = (): UseGetColorReturn => {
  const { theme } = useTheme();
  return useCallback<UseGetColorReturn>(
    (color) => {
      switch (theme) {
        case Theme.Light:
          return colors[`${color}Light`] as Color;
        case Theme.Dark:
          return colors[`${color}Dark`] as Color;
      }
    },
    [theme]
  );
};
